import * as React from "react"
import { Badge } from "@/components/ui/badge"
import { cn } from "@/lib/utils"

type Props = {
  category: string
  locked?: boolean
  className?: string
}

export function CategoryBadge({ category, locked, className }: Props) {
  return (
    <Badge variant={locked ? "frozen" : "secondary"} className={cn(className)}>
      {category}
    </Badge>
  )
}
